export default __webpack_public_path__ + "static/fireRomeo-ea982937fecd2e04585d0521d6b966a8.png";